import React from "react";

export default function StatusPill({ status, className = "" }) {
  const label = (status || "open").replace(/_/g, " ");
  return (
    <span className={`eb-status eb-status-${status} ${className}`}>{label}</span>
  );
}
